import * as React from 'react';

const DisplayQtyMinQtyMult = (props) => {
    const {single_product} = props;
    return (
        <>
            {single_product !== undefined &&
            single_product.QtyMin !== undefined &&
            <>
                <span className='min-mult-labal'>Min:</span>{single_product.QtyMin ? single_product.QtyMin : 0} &nbsp;
            </>
            }
            {single_product !== undefined &&
            single_product.QtyMult !== undefined &&
            <>
                <span className='min-mult-labal'>Mult:</span>{single_product.QtyMult ? single_product.QtyMult : 0} &nbsp;
            </>
            }
        </>
    );
}

export default DisplayQtyMinQtyMult;